import TrackLoginEvent from 'areas/Login/static/script/app/ui/track-login-event';
import LoginButtonUI from 'areas/Login/static/script/app/ui/login-button-ui';
import FacebookLoginButton from 'areas/Login/static/script/app/ui/facebook-login-button';
import * as LoginSignupEvents from 'core/script/app/ui/layout/login-signup-events';
import React from 'react';
import ReactDOM from 'react-dom';
import cookieUtil from 'tradera-utils/cookie';
import qs from 'qs';

export default function() {
    TrackLoginEvent.attachTo(document, {
        eventType: 'login'
    });
    LoginButtonUI.attachTo('[data-login-submit]');

    const search = qs.parse(window.location.search, {
        ignoreQueryPrefix: true
    });

    if (search['ReturnUrl']) {
        const cookieName = 'signup_referral_path';
        const expireDate = new Date();
        const value = window.location.origin + search['ReturnUrl'];
        expireDate.setTime(expireDate.getTime() + 10 * 60 * 1000);
        cookieUtil.createCookie(cookieName, value, expireDate);
    }

    // new react component
    let fbLoginButton = document.getElementById('facebook-login-button');
    if (fbLoginButton) {
        ReactDOM.render(
            <FacebookLoginButton
                facebookAppId={fbLoginButton.getAttribute(
                    'data-facebook-app-id'
                )}
                isModal={
                    fbLoginButton.getAttribute('data-is-modal') === 'True'
                        ? true
                        : false
                }
            />,
            fbLoginButton
        );
    }

    LoginSignupEvents.LoginWithPasswordButtonComponent.attachTo(
        '[data-login-submit]'
    );
}
